import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";

import CustomTabs from "components/CustomTabs";
import { selectCurrentRoles } from "features/auth/authSlice";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const BankingTabSection = ({activeTab}) => {
  const RolesFromToken = useSelector(selectCurrentRoles);
  const tabs = [
    {
      tabName: `${
        RolesFromToken?.groups?.includes("Banker") ||
        RolesFromToken?.groups?.includes("Bank_Of_Baroda_Banker")
          ? "Applications"
          : "Banking"
      }`,
      route: "/banking",
      component: "Banking",
      icon: <AccountBalanceOutlinedIcon />,
    },
    {
      tabName: `${
        RolesFromToken?.groups?.includes("Banker") ||
        RolesFromToken?.groups?.includes("Bank_Of_Baroda_Banker")
          ? "Dashboard"
          : "Analytics"
      }`,
      route: "/banking/analytics",
      component: `${
        RolesFromToken?.groups?.includes("Banker") ||
        RolesFromToken?.groups?.includes("Bank_Of_Baroda_Banker")
          ? "Dashboard"
          : "Analytics"
      }`,
      icon: <QueryStatsOutlinedIcon />,
    },
    {
      tabName: "Commission",
      route: "/banking/commission",
      component: "Commission",
      icon: <CurrencyRupeeOutlinedIcon />,
    },
     {
      tabName: "Invoicing",
      route: "/banking/invoice",
      component: "Invoicing",
      icon: <ReceiptLongOutlinedIcon />,
    },
  ];
  // const filteredTabs =
  //   RolesFromToken?.groups?.includes("Banker") ||
  //   RolesFromToken?.groups?.includes("Bank_Of_Baroda_Banker")
  //     ? tabs.filter((tab) => tab.tabName !== "Commission")
  //     : tabs;
const ROLE_TAB_RULES = {
  "Banking Admin": ["Commission", "Invoicing"],
  Banker: "HIDE_COMMISSION_INVOICING",
  Bank_Of_Baroda_Banker: "HIDE_COMMISSION_INVOICING",
};

const roles = RolesFromToken?.groups || [];

const filteredTabs = roles.includes("Banking Admin")
  ? tabs.filter((t) =>
      ROLE_TAB_RULES["Banking Admin"].includes(t.tabName)
    )
  : roles.some((r) => ROLE_TAB_RULES[r] === "HIDE_COMMISSION_INVOICING")
  ? tabs.filter(
      (t) => !["Commission", "Invoicing"].includes(t.tabName)
    )
  : tabs;

 
  return (
    <>
     <CustomTabs tabs={filteredTabs} activeTab={activeTab} />
    
    </>
  );
};

export default BankingTabSection;
